import firebase from 'firebase/app'
import 'firebase/firestore'
import { generateCardSecretSlug } from '../helpers/generateCardSecretSlug'

export async function findUser(email) {
  let user
  const querySnapshot = await firebase
    .firestore()
    .collection('users')
    .where('email', '==', email)
    .get()

  querySnapshot.forEach((doc) => {
    user = doc.data()
    user.uid = doc.id
  })

  if (!user) {
    throw new Error("User with given email doesn't exist.")
  }

  return user
}

export async function findLicense(license) {
  const licenseDoc = await firebase
    .firestore()
    .collection('licenses')
    .doc(license)
    .collection('config')
    .doc('metadata')
    .get()

  if (!licenseDoc.exists) {
    throw new Error("License with given ID doesn't exist.")
  }

  return licenseDoc.data()
}

export function updateLicense(license, data) {
  return firebase
    .firestore()
    .collection('licenses')
    .doc(license)
    .collection('config')
    .doc('metadata')
    .update(data)
}

export async function findCard(license, cardID) {
  const cardDoc = await firebase
    .firestore()
    .collection('licenses')
    .doc(license)
    .collection('cards')
    .doc(cardID)
    .get()

  if (!cardDoc.exists) {
    throw new Error("Card with given ID doesn't exist.")
  }

  return cardDoc.data()
}

export function applyLicense(license) {
  return firebase
    .firestore()
    .collection('users')
    .doc('00000')
    .update({ license })
}

export const addCardToLicense = (card) => {
  if (!card.cardID) throw Error('Card format is invalid')
  return firebase
    .firestore()
    .collection('licenses')
    .doc(card.license)
    .collection('cards')
    .doc(card.cardID)
    .set(card)
}

export async function deleteSlug(slug) {
  return firebase.firestore().collection('slugs').doc(slug).delete()
}

export const deleteCard = async (card) => {
  if (!card.cardID) throw new Error('Card format is invalid.')
  return firebase
    .firestore()
    .collection('licenses')
    .doc(card.license)
    .collection('cards')
    .doc(card.cardID)
    .delete()
}

export function setNewSlug(slug, card) {
  return firebase.firestore().collection('slugs').doc(slug).set(card)
}

export async function copyCardToOtherLicense(licenseFrom, licenseTo, cardID) {
  const oldCard = await findCard(licenseFrom, cardID)
  await findLicense(licenseTo)

  const cardToCopy = { ...oldCard }
  cardToCopy.license = licenseTo
  cardToCopy.cardURL = `https://konect.social/${generateCardSecretSlug(
    cardToCopy
  )}`

  await addCardToLicense(cardToCopy)

  if (cardToCopy.slug) {
    await deleteSlug(cardToCopy.slug)
    await setNewSlug(cardToCopy.slug, {
      license: cardToCopy.license,
      cardID: cardToCopy.cardID,
    })
  }

  await deleteCard(oldCard)
}

export async function moveUserToCustomLicense(email) {
  const user = await findUser(email)

  if (!user) {
    throw new Error('User not found.')
  }

  return firebase
    .firestore()
    .collection('licenses')
    .doc(user.license)
    .collection('config')
    .doc('metadata')
    .update({
      subscriptionName: 'custom',
    })
}
